import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { convertObjectKeysToSnakeCase } from "../../Shared/ConvertObjectKeysToSnakeCase";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getSkills = ({
  onResponse,
  onError,
  pageNumber,
  debouncedSkillNameForFuzzyFilter,
}) => {
  let queryString = '';

  if (!!debouncedSkillNameForFuzzyFilter) {
    queryString = `?page_number=${pageNumber}&debounced_skill_name_for_fuzzy_filter=${debouncedSkillNameForFuzzyFilter}`;
  } else {
    queryString = `?page_number=${pageNumber}`;
  }

  fetch(
    `/api/skills${queryString}`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createUnrecognizedSkill = ({
  body,
  onResponse,
  onError,
}) => {
  fetch(
    `/api/skills/create_unrecognized_skill`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const recognizeSkill = ({
  body,
  onResponse,
  onError,
}) => {
  fetch(
    `/api/skills/recognize_skill`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const disallowSkill = ({
  body,
  onResponse,
  onError,
}) => {
  fetch(
    `/api/skills/disallow_skill`,
    {
      method: HTTPRequestMethods.PUT,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(convertObjectKeysToSnakeCase(body)),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
